import React, { useState, useEffect, useRef } from 'react';
import { __ } from '@wordpress/i18n';

import ClipService from '../../../../../../service/clip-service';
import '../../../../../../assets/components/LibrarySearch.css';

const primaryMood = (clip) => {
    const t = clip.tags || {};
    if (t.mood) return t.mood;
    if (t.Mood) return t.Mood;
    if (Array.isArray(t.moods) && t.moods.length) return t.moods[0];
    return null;
};

// Estrae fino a 3 chip dai tag AI senza assumere una forma fissa (il tagging Moises
// dipende dal workflow): mostra i valori primitivi presenti, qualunque sia la chiave.
const chipsOf = (clip) => {
    const t = clip.tags || {};
    const out = [];
    for (const v of Object.values(t)) {
        if (out.length >= 3) break;
        if (typeof v === 'string' || typeof v === 'number') out.push(String(v));
        else if (Array.isArray(v) && v.length && (typeof v[0] === 'string' || typeof v[0] === 'number')) out.push(String(v[0]));
    }
    return out;
};

const hasTags = (clip) => clip.tags && Object.keys(clip.tags).length > 0;

const LibrarySearch = ({ projectId }) => {
    const [q, setQ] = useState('');
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [analyzing, setAnalyzing] = useState({});
    const timer = useRef(null);

    useEffect(() => {
        if (timer.current) clearTimeout(timer.current);
        const term = q.trim();
        if (!term || !projectId) {
            setResults([]);
            setLoading(false);
            return undefined;
        }
        setLoading(true);
        timer.current = setTimeout(async () => {
            try {
                const res = await ClipService.searchClipsAsync(projectId, term);
                setResults(Array.isArray(res) ? res : (res?.items || []));
            } catch (e) {
                setResults([]);
            }
            setLoading(false);
        }, 350);
        return () => {
            if (timer.current) clearTimeout(timer.current);
        };
    }, [q, projectId]);

    const handleDetect = async (clip) => {
        if (analyzing[clip.id]) return;
        setAnalyzing((prev) => ({ ...prev, [clip.id]: 'sent' }));
        try {
            await ClipService.analyzeClipAsync(clip.id);
        } catch (e) {
            // gestito dal network-service
        }
    };

    return (
        <div className="librarySearch">
            <input
                className="librarySearch__input"
                type="search"
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder={__('Cerca per nome, emozione, mood…', 'soundbetween')}
            />
            {q.trim() && (
                <div className="librarySearch__results">
                    {loading && <p className="librarySearch__hint">{__('Ricerca…', 'soundbetween')}</p>}
                    {!loading && results.length === 0 && (
                        <p className="librarySearch__hint">{__('Nessun risultato', 'soundbetween')}</p>
                    )}
                    {results.map((clip) => {
                        const mood = primaryMood(clip);
                        const chips = mood ? [] : chipsOf(clip);
                        return (
                            <div key={clip.id} className="librarySearch__item">
                                <span className="librarySearch__name">{clip.name}</span>
                                <span className="librarySearch__meta">
                                    {clip.clipType && (
                                        <span className="librarySearch__badge">{clip.clipType}</span>
                                    )}
                                    {mood && (
                                        <span className="librarySearch__badge librarySearch__badge--mood">{mood}</span>
                                    )}
                                    {chips.map((c, i) => (
                                        <span key={i} className="librarySearch__badge">{c}</span>
                                    ))}
                                    {!hasTags(clip) && (
                                        analyzing[clip.id]
                                            ? <span className="librarySearch__hint librarySearch__hint--inline">{__('Analisi avviata', 'soundbetween')}</span>
                                            : <button
                                                type="button"
                                                className="librarySearch__detect"
                                                onClick={() => handleDetect(clip)}>
                                                {__('Rileva mood', 'soundbetween')}
                                            </button>
                                    )}
                                </span>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default LibrarySearch;
